import i18n from '@i18next/i18n';
import CommonTips from '@com/common-tips';
import { IHistoryManager } from '@src/slide/application/service/history-manager/core/history-manager.interface';

export const DOC_REVERT = {
    BEGIN: 'revertBegin',
    ENG: 'revertEnd',
};

export default class HistoryRevertListener {
    public constructor(historyManager: IHistoryManager) {
        historyManager.on(DOC_REVERT.BEGIN, () => {
            CommonTips.getInstance().show({
                message: i18n.t('正在还原，请稍候...'),
            });
        });
        historyManager.on(DOC_REVERT.ENG, () => {
            CommonTips.getInstance().hide();
        });
    }
}
